import { Box, CircularProgress } from '@mui/material';
import useDispatch from 'hooks/useDispatch';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getUnitTradeChartList } from 'store/slices/investment/investmentSlice';
import FluctuationChart from './FluctuationChart';

function FluctuationChartWrapper({ itemData }) {
  const dispatch = useDispatch();
  const chartData = useSelector(
    (state) => state.investment?.unitTradeChartList
  );

  const [loading, setLoading] = useState(true);

  const handleGetUnitChartData = async () => {
    try {
      setLoading(true);

      await dispatch(getUnitTradeChartList(itemData?.unitTradeId));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetUnitChartData();
  }, [itemData]);

  return (
    <>
      {loading ? (
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
          minHeight={'100px'}
        >
          <CircularProgress size={15} color="secondary" />
        </Box>
      ) : (
        <FluctuationChart data={chartData} />
      )}
    </>
  );
}

export default FluctuationChartWrapper;
